import React from 'react';
import { useHistory } from 'react-router-dom';
import { PrimaryButton } from '@workday/canvas-kit-react/button';
import styles from './confirm-email/confirm-email.module.scss';
import { autoId } from '@workday/upc-common';
import { LoginLink } from '../../shared/login-link/login-link';

import { RESET_PASSWORD_VERIFY_AUTHENTICATOR_PATH } from '../../react-router-paths';
import { useTranslation } from 'react-i18next';
import { ID_RESET_PASSWORD_EMAIL_INIT } from '../../autoIds';
export function RotateCred() {
    const history = useHistory();

    const { t } = useTranslation('auth');

    function onResetPasswordClick() {
        history.push(RESET_PASSWORD_VERIFY_AUTHENTICATOR_PATH);
    }

    return (
        <div className={styles.resetPasswordEmailEntry}>
            <h1 className={styles.title}>{t('AccountCompromised.title')}</h1>
            <p className={styles.body}>{t('AccountCompromised.description')}</p>

            <PrimaryButton
                onClick={onResetPasswordClick}
                {...autoId(ID_RESET_PASSWORD_EMAIL_INIT)}
                size='large'
                grow={true}
                marginBottom='1rem'>
                {t('ConfirmEmail.submitButton')}
            </PrimaryButton>
            <LoginLink />
        </div>
    );
}
